const filteredIds = ["P5759", "P5852", "P5757", "P5760"];
import staIdsData from "@/utils/staIdsData.json";
const filteredData = (cimissData: any[]) => {
  console.log(cimissData);
  if (!cimissData || cimissData.length == 0) return [];
  return cimissData.filter((e: any) => !filteredIds.includes(e.station_id_c));
};

const redefineStationInfo = (cimissData: []) => {
  if (!cimissData || cimissData.length == 0) return [];
  cimissData.map((e: any) => {
    staIdsData.map((i: any) => {
      if (e.station_id_c === i.station_id_c) {
        e.station_name = i.station_name;

        if (
          e.station_id_c === "P6977" ||
          e.station_id_c === "P6972" ||
          e.station_id_c === "P6973" ||
          e.station_id_c === "57874" ||
          e.station_id_c === "P6956"
        ) {
          e.lat = i.lat;
          e.lon = i.lon;
        }
      }
    });
  });
  return cimissData;
};

export { filteredData, redefineStationInfo };
